/**
 * @generated SignedSource<<422fc5e304b309019860ad1a41222e6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountBillingInfoCardFragment$data = {
  readonly cardBrand: string | null;
  readonly cardLastFour: string | null;
  readonly cardCountryId: string | null;
  readonly " $fragmentType": "accountBillingInfoCardFragment";
};
export type accountBillingInfoCardFragment$key = {
  readonly " $data"?: accountBillingInfoCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountBillingInfoCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountBillingInfoCardFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardBrand",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardLastFour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardCountryId",
      "storageKey": null
    }
  ],
  "type": "AccountBillingInfo",
  "abstractKey": null
};

(node as any).hash = "8e8e2ea24a59fe957afc9f227f89c01b";

export default node;
